<template>
    <v-form>
        <v-row>
            <!-- <v-col>
                <v-autocomplete
                    label="Warehouse"
                    v-model="form.warehouse_id"
                    :items="warehouses"
                    @update:search-input="searchWarehouses"
                    item-value="id"
                    item-text="name"
                    outlined
                    dense
                    clearable
                    hide-details="auto">
                </v-autocomplete>
            </v-col> -->
        </v-row>
        <v-row>
            <v-col>
                <v-autocomplete
                    label="Group"
                    v-model="form.item_group_id"
                    :items="groups"
                    @update:search-input="searchGroups"
                    item-value="id"
                    item-text="display_name"
                    outlined
                    dense
                    clearable
                    hide-details="auto">
                </v-autocomplete>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    label="Location"
                    outlined
                    dense
                    hide-details="auto"
                    v-model="form.location"
                    >
                </v-text-field>
            </v-col>
        </v-row>
        
    </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    name: "WarehouseItemListSearchForm",
    props: {
        value: Object
    },
    data() {
        return {
            form: {
                item_group_id: null,
                location: null,
                warehouse_id: null
            }
        }
    },
    watch: {
        form: {
            deep: true,
            handler(form) {
                this.$emit("input", {...form})
            }
        }
    },
    computed: {
        ...mapGetters({
            groups: "stock/itemGroup/search/data",
            warehouses: "warehouse/warehouse/search/data"
        })
    },
    methods: {
        ...mapActions({
            searchGroups: "stock/itemGroup/search/get",
            searchWarehouses: "warehouse/warehouse/search/get"
        })
    },
    mounted() {
        if(this.value) {
            this.form = {...this.value}
        }
    }
}
</script>

<style>

</style>